import {useSelector, useDispatch} from 'react-redux';
import React from 'react';
import Modal from 'react-modal';
import {Translate, I18n} from 'react-redux-i18n';

import {Icon, stringUtils} from 'front-onceforall-core';

import {recordGAEvent} from '../../../../../utils/analytics';
import {VITRINE_ACCESSED} from '../../../../../utils/constant';
import {getVitrineUrl, getDiscoverVitrineUrlFromLocale} from '../../../../../utils/path';
import {toggleModal} from '../../../../../actions/modals';
import {pathResolver} from '../../../../../utils/basePathHelper';

const getStrongText = path => (
  <div className='my-2'>
    {stringUtils.getStrongs(I18n.t(path))}
  </div>
);

function gaEventDismissedModal() {
  recordGAEvent('Vitrine', 'Dismissed Vitrine modal');
}

function gaEventAccessVitrine() {
  recordGAEvent('Vitrine', 'Accessed Vitrine from modal');
}

function gaEventAccessLearnMore() {
  recordGAEvent('Vitrine', 'Accessed Vitrine "Learn more" from modal');
}

function AccessVitrineModal() {
  const dispatch = useDispatch();
  const [organisation = {}, showModal, locale] = useSelector(globalState => ([
    globalState.organisation,
    globalState.modals.accessVitrineModal,
    globalState.i18n.locale
  ]));

  const url = React.useMemo(() => getVitrineUrl(organisation?.organisationId), [organisation?.organisationId]);

  function closeModal() {
    gaEventDismissedModal();
    dispatch(toggleModal('accessVitrineModal', false));
  }

  function handleConfirm() {
    gaEventAccessVitrine();
    localStorage.setItem(VITRINE_ACCESSED, 'true');
    dispatch(toggleModal('accessVitrineModal', false));
  }

  return (
    <Modal
      defaultStyles={{
        overlay: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1
        },
        content: {
          backgroundColor: '#fff',
          borderRadius: 4,
          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 32px 0px',
          minWidth: 300,
          maxWidth: 700,
          outline: 0,
          padding: 20,
          position: 'relative'
        }
      }}
      isOpen={showModal}
      onRequestClose={closeModal}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <div>
        <div className='my-4 d-flex flex-column'>
          <div className='d-flex flex-row justify-content-center align-items-center'>
            <img
              alt="icon vitrine"
              src={pathResolver('resources/img/icon_vitrine.png')}
              style={{width: '70px'}}
              className="mr-5"
            />
            {getStrongText('vitrine.access.text1')}
          </div>
          <div className='my-4 d-flex flex-column align-items-start'>
            {getStrongText('vitrine.access.text2')}
            {getStrongText('vitrine.access.text3')}
            {getStrongText('vitrine.access.text4')}
            <a
              className='my-2'
              target="_blank"
              href={getDiscoverVitrineUrlFromLocale(locale)}
              rel="noopener noreferrer"
              title={I18n.t('vitrine.access.text5')}
              onClick={gaEventAccessLearnMore}
            >
              <Translate value='vitrine.access.text5'/>
            </a>
            {getStrongText('vitrine.access.text6')}
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <button
            type="button"
            className="large secondary inline-container"
            onClick={closeModal}
            data-id="cancel"
          >
            <Icon icon="go-back"/>
            <Translate value="action.cancel"/>
          </button>
          <div onClick={handleConfirm}>
            <a
              target="_blank"
              href={url}
              className="button-square px-1 flex-container"
              rel="noopener noreferrer"
              title={I18n.t('vitrine.access.confirm')}
            >
              <Translate value="vitrine.access.confirm"/>
            </a>
          </div>
        </div>

      </div>
    </Modal>
  );
}

export default AccessVitrineModal;
